module.exports = __webpack_public_path__ + "static/img/6.90ea4a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/eng/6.png
// module id = c6Zl
// module chunks = 0